import(/* webpackMode: "eager", webpackExports: ["default"] */ "/code/src/core/sections/filterContentList/new/clubResults/index.js");
